import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument } from '@/models/client/message-center'

const URL = '/rest/customer/subscribe-message'
const DELURL = '/rest/customer/subscribe-message/{id}'
const DELETE = '/rest/customer/subscribe-message/bat-del'

export default {
  list ({search}, cb) {
    let info = convert.toJson(search, SearchArgument)
    http.get(URL, {params: info}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  delOne (id, cb) {
    http.delete(DELURL.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  setRead (id, cb) {
    http.put(DELURL.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  delAll ({ids}, cb) {
    http.delete(DELETE, {params: {ids}}).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/massage-center.js